import { useFaqWidget } from "../../../providers/context";
import { createEffect, createSignal, onMount } from "solid-js";
import { useTranslation } from "~/primitives/translator";

export function ContentFrame() {

	const {
		search,
		selected,
		handleLinkClick
	} = useFaqWidget();

	let articleFrame: HTMLDivElement | undefined;

	const [markJS, setMarkJS] = createSignal<HTMLScriptElement>();

	onMount(() => {

		articleFrame!.addEventListener('click', (e) => {
			const target = e.target as HTMLElement;
			if (target?.tagName === 'A') {
				handleLinkClick(e);
			}
		});

		const script = document.createElement('script');
		script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/mark.min.js';
		script.async = true;

		script.addEventListener('load', () => {
			setMarkJS(script);
		});

		document.body.appendChild(script);
	});

	createEffect(() => {

		const article = selected();
		const script = markJS();
		const searches = search();

		if (!script || !article) {
			return;
		}

		useTranslation(article?.mainAnswer).then(main => {

			articleFrame!.innerHTML = main;

			const mark = new (window as any).Mark(articleFrame!);
			mark.mark(searches, { separateWordSearch: false });

			if (!searches) {
				mark.unmark();
			}
		});
	});

	return (
		<>
			<div
				class="mt-4 min-w-full prose prose-a:text-accent prose-a:font-normal"
				ref={articleFrame}
			/>
		</>
	);
}